import type { Offer } from '@/types/types'
import { mapApiChannelToUi } from '@/utils/offerHelpers'
import type { BrandAppOfferCard } from './brandAppContract'

export const OFFER_TITLE_MAX_LENGTH = 80
export const OFFER_DESCRIPTION_MAX_LENGTH = 2000
export const OFFER_BUTTON_MAX_LENGTH = 40

export const prefillOfferCard = (offer: Offer, ctaLabel: string): BrandAppOfferCard => ({
  offerId: offer.id,
  publicId: offer.publicId,
  rewardId: offer.rewardId,
  image: offer.reward?.pictureUrl ?? '',
  title: offer.name,
  description: offer.reward?.description ?? '',
  ctaLabel
})

const isOnline = (offer: Offer) =>
  !offer.channels?.length || offer.channels.some((channel) => mapApiChannelToUi(channel).includes('online'))

export const isBrandAppOffer = (offer: Offer) => isOnline(offer) && offer.status !== 'expired'

export type OfferField = 'image' | 'title' | 'description' | 'ctaLabel'

export const offerCardErrors = (card: BrandAppOfferCard) => {
  const errors: Partial<Record<OfferField, string>> = {}
  if (!card.image.trim()) errors.image = 'imageRequired'
  if (!card.title.trim()) errors.title = 'titleRequired'
  else if (card.title.length > OFFER_TITLE_MAX_LENGTH) errors.title = 'titleTooLong'
  if (card.description.length > OFFER_DESCRIPTION_MAX_LENGTH) errors.description = 'descriptionTooLong'
  if (!card.ctaLabel.trim()) errors.ctaLabel = 'buttonRequired'
  else if (card.ctaLabel.length > OFFER_BUTTON_MAX_LENGTH) errors.ctaLabel = 'buttonTooLong'
  return errors
}
